export default __webpack_public_path__ + "static/media/boots_of_vicious_frenzy.ddf62768.jpg";